import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateTicket, deleteTicket, createTicket } from "../services/ticketApi";

export function useCreateTicket(queryKey, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTicket,
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, (old) => {
        console.log("Old data:", old);
        return old ? [...old, data] : [data];
      });
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateTicket(queryKey, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTicket,
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteTicket(queryKey, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTicket,
    onSuccess: (data, id) => {
      queryClient.setQueryData(queryKey, (old) => old?.filter((item) => item.id !== id));
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
